import { render, staticRenderFns } from "./LateFeesCard.vue?vue&type=template&id=4a89a3fa&scoped=true&"
import script from "./LateFeesCard.vue?vue&type=script&lang=ts&"
export * from "./LateFeesCard.vue?vue&type=script&lang=ts&"
import style0 from "./LateFeesCard.vue?vue&type=style&index=0&id=4a89a3fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a89a3fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
